// src/services/AnnulationService.js

import { base_url } from "../utils/constante";

// ⚠️ Même URL de base que StripeConnectService.js / BilletterieService.js
const API_URL = base_url
const token = () => localStorage.getItem("token") || sessionStorage.getItem("token");

const appel = async (chemin, methode = "GET", corps = null) => {
    const res = await fetch(`${API_URL}${chemin}`, {
        method: methode,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token()}`,
        },
        body: corps ? JSON.stringify(corps) : null,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.success === false) throw new Error(data.message || "Erreur");
    return data;
};

export const MOTIFS_RESERVATION = [
    { valeur: "manque_places", label: "Manque de places" },
    { valeur: "changement_prix", label: "Changement de prix" },
    { valeur: "erreur", label: "Erreur de réservation" },
    { valeur: "autre", label: "Autre" },
];

export const MOTIFS_EVENEMENT = [
    { valeur: "evenement_annule", label: "Événement annulé" },
    { valeur: "report", label: "Événement reporté" },
    { valeur: "autre", label: "Autre" },
];

/** Organisateur : annule une réservation (acheteur remboursé à 100 %) */
export const annulerReservationOrganisateur = (id, motif, commentaire) =>
    appel(`createur/reservations/${id}/annuler`, "POST", { motif, commentaire });

/** Organisateur : annule tout l'événement (tous les acheteurs remboursés à 100 %) */
export const annulerEvenementOrganisateur = (id, motif, commentaire) =>
    appel(`createur/evenement/${id}/annuler`, "POST", { motif, commentaire });

/** Admin : suivi des annulations */
export const getSuiviAnnulations = () => appel("admin/annulations");